import { handleActions } from "redux-actions";

import {
  SET_LOADING,
  SET_STATUS,
  RESET_FILTERS,
  FETCH_REGIONS_SUCCESS,
  ADD_REGION_SUCCESS,
  EDIT_REGION_SUCCESS,
  SET_ERROR,
  DELETE_REGION_SUCCESS,
  SET_DEFAULT_REGION_SUCCESS
} from "./regionsSagas";
import sortBy from "lodash/sortBy";

export const initialState = {
  isLoading: true,
  regions: [],
  locations: [],
  status: "idle",
  errors: null
};

export default handleActions(
  {
    [SET_ERROR]: (state, action) => ({
      ...state,
      status: "failed",
      errors: action.payload
    }),
    [SET_STATUS]: (state, action) => ({
      ...state,
      status: action.payload
    }),
    [RESET_FILTERS]: (state) => ({
      ...state,
      status: "idle",
      errors: null
    }),
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [FETCH_REGIONS_SUCCESS]: (state, action) => ({
      ...state,
      regions: action.payload.regions,
      locations: action.payload.locations,
      defaultRegionId: action.payload.defaultRegionId
    }),
    [ADD_REGION_SUCCESS]: (state, { payload: { id, name, location_ids } }) => {
      let updatedRegions = state.regions.map((region) => {
        return {
          ...region,
          location_ids: region.location_ids.filter((id) => !location_ids.includes(id))
        };
      });

      return {
        ...state,
        status: "success",
        regions: [
          updatedRegions[0],
          ...sortByName([...updatedRegions.slice(1), { id, name, location_ids }])
        ]
      };
    },
    [EDIT_REGION_SUCCESS]: (state, { payload: { id, name, location_ids } }) => {
      let unassignedLocations = [];
      let updatedRegions = state.regions.map((region) => {
        if (region.id == id) {
          region.location_ids.forEach(
            (id) => !location_ids.includes(id) && unassignedLocations.push(id)
          );
          return { ...region, id, name, location_ids };
        }

        return {
          ...region,
          location_ids: region.location_ids.filter((id) => !location_ids.includes(id))
        };
      });

      const defaultRegion = {
        ...updatedRegions[0],
        location_ids: [...updatedRegions[0].location_ids, ...unassignedLocations]
      };

      return {
        ...state,
        status: "success",
        regions: [defaultRegion, ...sortByName([...updatedRegions.slice(1)])]
      };
    },
    [SET_DEFAULT_REGION_SUCCESS]: (state, { payload }) => {
      let defaultRegion;

      let newRegions = state.regions.reduce((acc, region) => {
        if (region.id === payload) {
          defaultRegion = { ...region, isDefault: true };
          return acc;
        }
        acc.push({ ...region, isDefault: false });
        return acc;
      }, []);

      return {
        ...state,
        status: "success",
        regions: [defaultRegion, ...sortByName(newRegions)]
      };
    },
    [DELETE_REGION_SUCCESS]: (state, { payload: { id } }) => {
      return {
        ...state,
        status: "success",
        regions: state.regions.filter((region) => region.id !== id)
      };
    }
  },

  initialState
);

const sortByName = (arr) => {
  return sortBy(arr, (obj) => obj.name.toLowerCase());
};
